import {
  Agendamiento,
  IDataPreventa,
  IDataProspecto,
} from '@/shared/interfaces';

export type SaveRecoordinacionDataPost = Pick<
  Agendamiento,
  | 'fecha_instalacion'
  | 'hora_instalacion'
  | 'estado_llamada'
  | 'fecha_hora_llamada'
  | 'observaciones'
>;

export type AproveRecoordinacionData = Pick<
  Agendamiento,
  'estado_agendamiento'
> &
  Pick<
    IDataPreventa,
    | 'persona_referencia_nombre'
    | 'persona_referencia_parentesco'
    | 'persona_referencia_celular'
    | 'provincia'
    | 'ciudad'
    | 'zona'
    | 'sector'
    | 'direccion'
  > &
  Pick<IDataProspecto, 'pais'> &
  Pick<
    Agendamiento,
    | 'estado_llamada'
    | 'observaciones'
    | 'fecha_hora_llamada'
    | 'email'
    | 'celular'
    | 'celular_2'
    | 'fecha_instalacion'
    | 'hora_instalacion'
    | 'coordenadas'
    | 'nap'
    | 'distancia'
    | 'flota'
  > & {
    motivo_rechazo?: string | null;
    observacion_rechazo?: string | null;
    id_preventa?: string;
    cantidad_reversos?: number;
    horas: string[]
    fecha_instalacion_original?: string
    hora_instalacion_original?: string
  };


export type AproveRecoordinacionMinifiedData = Pick<
  Agendamiento,
  | 'fecha_instalacion'
  | 'estado_agendamiento'
  | 'hora_instalacion'
  | 'flota_data'
>

export enum TipoActividadSoftnetEnum {
  INSTALACION = 'Instalación',
  MIGRACION = 'Migración',
  TRASLADO = 'Traslado',
  VISITAS = 'Visitas',
  RETIROS = 'Retiros',
}

export const TipoActividadSoftnet = [
  TipoActividadSoftnetEnum.INSTALACION,
  TipoActividadSoftnetEnum.MIGRACION,
  TipoActividadSoftnetEnum.TRASLADO,
  TipoActividadSoftnetEnum.VISITAS,
]



export interface CalendarEventSeguimientoAct {
  title?: string;
  start?: Date | string;   
  end?: Date | string;     
  color?: string;
  id_actividad?: string;
  tipo?: string; 
  cargo?: string;
}



export interface TecnicosSoftnet {
  id_tecnico: number;
  nombre_tecnico: string;
  nombre_ciudad: string;
  zona: string;
  celular: string;
  cod_tecnico: number;
  tipo_tecnico: string | null;
  alias: string | null;
}


export interface BitacoraSoftnet {
  fecha_llamada: string;        // formato YYYY-MM-DD
  hora_llamada: string;         // formato HH:mm:ss
  acuerdo: string;
  nombre_empleado: string;
}



export interface Actividad {
  id: number;
  vendedor: string;
  cedula_identidad: string;
  nombre_cliente: string;
  telefono_fijo: string;
  telefono_movil: string;
  telefono_adicional: string;
  ciudad: string;
  direccion: string;
  sector: string;
  coordenadas: string; // ej: "-2.10,-79.97"
  tipo_ins: number;
  nombre_plan: string;
  observaciones: string;
  fecha_hora: string;     // "YYYY-MM-DD HH:mm:ss"
  fecha: string;          // "YYYY-MM-DD"
  hora_inicio: string;    // "HH:mm:ss"
  activacion: string;
  nombre_tecnico: string;
  cargo: string;
  id_tecnico: string;
  cod_tecnico: number;
  ingreso_pyl: string | null;
  salida_pyl: string | null;
  alias: string | null;
  estado_tecnico: string;
  fecha_informe: string;   // "YYYY-MM-DD"
  detalle_informe: string;
  tipo_servicio: string;
  tipo_actividad: "instalacion" | "mantenimiento" | string; // ajustá si hay más
  visita_culminada: number; // parece flag (0/1)
  en_visita: number;        // idem
  observaciones_vendedor: string;
  fecha_llamada: string;    // "YYYY-MM-DD HH:mm:ss"
  zona: string;
  nombre_categoria: string | null;
  nombre_subcategoria: string | null;
}



export interface ActividadesPagingRes {
  count: number;
  next: string;
  previous: string;
  data: Actividad[];
  conteo_por_fecha: any;
}